import { createRef, useEffect, useState } from 'react';
import Presenter from './Presenter';
import { IContainerProps } from './types';
import { IBusiness } from '../../state/api/types';

const BusinessListContainer = (props: IContainerProps) => {
    const [businessRefs, setBusinessRefs] = useState([]);
    const [businessSelected, setBusinessSelected] = useState<IBusiness | null>(null);

    useEffect(() => {
        const refs1 = Array.from({ length: props.businesses.length }, (_, i) => businessRefs[i] || createRef())
        setBusinessRefs(refs1);
    }, [props.businesses]);

    return (
        <Presenter
            {...props}
            businessRefs={businessRefs}
            businessSelected={businessSelected}
        />
    );
};

export default BusinessListContainer;
